const topics = [
  {
    image: "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20scene%20with%20warm%20orange%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20entertainment%20news%20theme%2C%20digital%20art%20composition%2C%20no%20faces%2C%20bold%20visual%20style&width=800&height=450&seq=carousel-01-featured&orientation=landscape",
    tag: "本月焦点",
    title: "网红圈年度大事件回顾：那些让你惊掉下巴的名场面",
    desc: "盘点今年以来网红圈最具话题度的翻车与爆料事件，从直播事故到私生活曝光，一次看个够。",
    count: "36条视频",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Stylized%20dark%20abstract%20background%20with%20coral%20red%20accents%2C%20cinematic%20media%20theme%2C%20dramatic%20composition%2C%20modern%20entertainment%20aesthetic%2C%20no%20people%2C%20bold%20design&width=800&height=450&seq=carousel-02-featured&orientation=landscape",
    tag: "深度专题",
    title: "直播带货乱象调查：那些被平台封禁的主播后来都去哪了",
    desc: "深入追踪多位因违规被封禁的头部主播近况，揭露直播行业背后的灰色地带。",
    count: "24条视频",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20digital%20art%20with%20warm%20golden%20orange%20highlights%2C%20mysterious%20media%20theme%2C%20dramatic%20shadow%20play%2C%20no%20faces%2C%20modern%20composition&width=800&height=450&seq=carousel-03-featured&orientation=landscape",
    tag: "独家爆料",
    title: "素人爆料专栏：那些被主流媒体忽略的真实吃瓜故事",
    desc: "来自普通网友的真实投稿，从职场内幕到邻里纠纷，每一个故事都值得被看见。",
    count: "18条视频",
  },
  {
    image: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20cinematic%20background%20with%20dramatic%20lighting%2C%20entertainment%20industry%20theme%2C%20digital%20collage%20style%2C%20no%20faces%2C%20modern%20bold%20visual%20design&width=800&height=450&seq=carousel-04-featured&orientation=landscape",
    tag: "热门合集",
    title: "娱乐圈CP塌房全记录：那些年我们磕过的假CP都怎么样了",
    desc: "从甜蜜互动到互相拉黑，娱乐圈那些曾经让人上头的CP塌房瞬间合集。",
    count: "42条视频",
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            精选专题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            精心策划的吃瓜专题合集，带你深度了解每一个热门事件的前因后果
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {topics.map((topic, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/40 transition-colors cursor-pointer group flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-[220px] md:w-[260px] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
                <img
                  src={topic.image}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md">
                  {topic.tag}
                </span>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {topic.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                    {topic.desc}
                  </p>
                </div>
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200/60">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-video-line"></i> {topic.count}
                  </span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer">
                    查看专题 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}